/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProjetRequest } from '../models/ProjetRequest';
import type { ProjetResource } from '../models/ProjetResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ProjetService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Classer un projet sans suite
     * Marque le projet refuse, date le classement et enregistre le motif `ID_MOTIF_SANS_SUITE`. Le projet reste consultable.
     * @param id
     * @param idMotifSansSuite
     * @returns ProjetResource `ProjetResource`
     * @throws ApiError
     */
    public projetCancel(
        id: string,
        idMotifSansSuite: number,
    ): CancelablePromise<ProjetResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projets/{id}/cancel',
            path: {
                'id': id,
            },
            query: {
                'ID_MOTIF_SANS_SUITE': idMotifSansSuite,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Projets d'une periode
     * Projets crees entre `DATE_DEBUT` et `DATE_FIN`, du plus recent au plus ancien, avec client, adresse de chantier et rendez-vous. Un commercial ne voit que ses projets ; un directeur commercial les voit tous. Filtres exacts disponibles : `filter[DATE_SANS_SUITE]`, `filter[REFUSE]`, `filter[TYPE_PROJET]`, `filter[IDRESPONSABLEPROJET]`.
     * @param dateDebut
     * @param dateFin
     * @param type
     * @returns ProjetResource Array of `ProjetResource`
     * @throws ApiError
     */
    public projetsIndex(
        dateDebut: string,
        dateFin: string,
        type?: 'assignment' | 'to_contact' | 'without_rdv' | 'without_quote' | 'with_quote' | 'with_signed_quote' | 'without_continuation' | 'to_relaunch' | 'all',
    ): CancelablePromise<Array<ProjetResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projets',
            query: {
                'TYPE': type,
                'DATE_DEBUT': dateDebut,
                'DATE_FIN': dateFin,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Creer un projet
     * Pour un client existant (`IDCLIENT`, 404 sinon), avec ses adresses. Le projet est affecte au personnel connecte.
     * @param requestBody
     * @returns ProjetResource `ProjetResource`
     * @throws ApiError
     */
    public projetsStore(
        requestBody?: ProjetRequest,
    ): CancelablePromise<ProjetResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/projets',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'un projet
     * Avec adresses de chantier et de facturation, rendez-vous, devis et client.
     * @param id
     * @returns ProjetResource `ProjetResource`
     * @throws ApiError
     */
    public projetsShow(
        id: string,
    ): CancelablePromise<ProjetResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projets/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Modifier un projet
     * Met a jour le projet et, si elles sont envoyees, ses adresses (`ADRESSE_CHANTIER`, `ADRESSE_FACTURATION`, champs partiels). Changer le responsable (`IDRESPONSABLEPROJET`) aligne l'agence du projet sur la sienne et le designe aussi comme responsable du client. 404 si le projet ou l'une de ses adresses n'existe pas.
     * @param id
     * @param requestBody
     * @returns ProjetResource `ProjetResource`
     * @throws ApiError
     */
    public projetsUpdate(
        id: string,
        requestBody?: ProjetRequest,
    ): CancelablePromise<ProjetResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/projets/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer un projet
     * Suppression definitive. Renvoie le projet supprime.
     * @param id
     * @returns ProjetResource `ProjetResource`
     * @throws ApiError
     */
    public projetsDestroy(
        id: string,
    ): CancelablePromise<ProjetResource> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/projets/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
}
